import script from "./AudioGuideModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioGuideModal.vue?vue&type=script&setup=true&lang=js"

import "./AudioGuideModal.vue?vue&type=style&index=0&id=ca954204&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca954204"]])

export default __exports__